module.exports = __webpack_public_path__ + "img/no-inquiry.7701d145.svg";